import component from './PageAiCreator.vue'
export default component
